// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2SJHp","avatar":"style_avatar__GDV-N","avatarDark":"style_avatarDark__26_-F"};